<template>
  <u-input
    v-model="q"
    v-bind="$attrs"
    :placeholder="placeholder"
    :size="size"
    autocomplete="off"
    icon="i-ri-search-line"
    :ui="searchConfig"
    :loading="loading"
    @keyup.enter="onSearch"
  >
    <template #trailing>
      <u-button
        v-show="q && q !== ''"
        color="gray"
        variant="link"
        :icon="COMMON_ICONS.close"
        :padded="false"
        @click="clear"
      />
    </template>
  </u-input>
</template>

<script setup>
  const props = defineProps({
    modelValue: String,
    placeholder: {
      type: String,
      default: 'Search'
    },
    loading: Boolean,
    clearOnEmpty: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'sm'
    },
    ui: {
      type: Object,
      default: () => ({})
    }
  });

  const emit = defineEmits(['update:modelValue', 'search', 'clear']);

  const q = defineModel();

  function clear() {
    q.value = '';
    emit('clear');
  }

  function onSearch() {
    emit('search', {q: q.value});
  }

  const defaultSearchConfig = computed(() => ({
    wrapper: 'w-full sm:w-auto',
    trailing: {
      padding: {
        [props.size]: 'pe-6'
      }
    },
    icon: {
      trailing: {
        pointer: '',
        padding: {
          [props.size]: 'px-1.5'
        }
      }
    }
  }));

  const searchConfig = computed(() => mergeUi(defaultSearchConfig.value, props.ui));

  function mergeUi(base, override) {
    const merged = {...base};

    Object.entries(override || {}).forEach(([key, value]) => {
      if (isPlainObject(value) && isPlainObject(merged[key])) {
        merged[key] = mergeUi(merged[key], value);
        return;
      }

      merged[key] = value;
    });

    return merged;
  }

  function isPlainObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  watch(q, newVal => {
    if (!newVal && props.clearOnEmpty) {
      clear();
    }
  });

</script>
